
export const FormFooter = () => {
    return (
        <div className="col-12 footer my-2 my-md-4">
            <div className="row px-md-40">
                <div className="col-5 col-md-2">
                    <ul className="nav font-10">
                        <li className="nav-item">
                            <div className="nav-link pl-0 text-nowrap">©{new Date().getFullYear()} All Rights Reserved</div>
                        </li>
                    </ul>
                </div>
                <div className="col-7 col-md-10">
                    <ul className="nav font-10">
                        {/* <li className="nav-item">
                            <a href="#" className="nav-link text-dark pl-0">
                                Terms of Service
                            </a>
                        </li> */}
                        <li className="nav-item">
                            <a href="https://dubaicommercity.ae/privacy-policy/" target="_blank"   className="nav-link text-dark">
                                Privacy Policy
                            </a>
                        </li>
                        <li className="nav-item">
                            <a  href="https://dubaicommercity.ae/privacy-policy/#Use-of-cookies " target="_blank"  className="nav-link text-dark">
                                Cookies Policy
                            </a>
                        </li>
                        <li className="nav-item">
  <a
    href={`mailto:partnership@dubaicommercity.ae
      ?subject=Support%20Request%20-%20Dubai%20CommerCity
      &body=Dear%20Support%20Team,%0D%0A%0D%0A
      I%20need%20assistance%20with%20the%20following%20issue:%0D%0A
      [Describe%20your%20issue%20here]%0D%0A%0D%0A
      Name:%20%0D%0A
      Company:%20%0D%0A
      Contact%20Number:%20%0D%0A%0D%0A
      Thank%20you,%0D%0A
      [Your%20Name]`}
    className="nav-link px-1 text-dark font-weight-600"
  >
    Get Support
  </a>
</li>

                    </ul>
                </div>
            </div>
        </div>
    )
}